import { ScheduleRule } from '@jms/model/scheduling';
import { WorkBuddyDialogService } from '@workbuddy/ui/v2/blocks/dialog';
import { ScheduleEditorContext } from './schedule.editor.context';
import { ScheduleEditorDialogComponent } from './schedule.editor.dialog.component';
import { ScheduleEditorDates, ScheduleEditorResult } from './schedule.editor.launcher.contract';

/** Paper 7-series width. Shrinks on a narrow viewport rather than overflowing it. */
const DIALOG_WIDTH = 'min(480px, calc(100vw - 40px))';

export interface ScheduleEditorOpenOptions {
  context: ScheduleEditorContext;
  model?: ScheduleRule;
  readonly?: boolean;
  dates?: ScheduleEditorDates;
}

/**
 * Opens the pattern editor as a v2 modal. The one place the dialog's chrome is decided, so the field's
 * launcher and a host that edits many records at once (bulk Set schedule) cannot drift apart.
 */
export function openScheduleEditor(dialogs: WorkBuddyDialogService, options: ScheduleEditorOpenOptions): Promise<ScheduleEditorResult | undefined> {

  const context = options.context;

  return dialogs.modal<ScheduleEditorResult, ScheduleEditorDialogComponent>(ScheduleEditorDialogComponent, {
    width: DIALOG_WIDTH,
    // The editor reveals and hides whole blocks as the kind and repeat change; a centred dialog would
    // jump on every one of those switches.
    align: 'top',
    // All three exits — cross, Escape, backdrop — resolve undefined, which callers treat as "leave the
    // existing schedule untouched".
    close: { backdrop: true },
    inputs: {
      model: options.model,
      readonly: options.readonly ?? false,
      startsOn: options.dates?.startsOn,
      lastCompleted: options.dates?.lastCompleted,
      taskName: context.taskName,
      effectiveFrom: context.effectiveFrom,
      effectiveTo: context.effectiveTo,
      timezone: context.timezone,
      today: context.today,
      workWeek: context.workWeek,
      holidays: context.holidays,
      allowedKinds: context.allowedKinds,
      allowedEndings: context.allowedEndings,
      mode: context.mode ?? 'live',
    },
    aria: { label: 'Schedule' },
  });
}
